import { BuildConfig } from 'env/env.config';

// The alt/title text for the school logo, in ONE place.
//
// ── WHAT WENT WRONG, BECAUSE THE SHAPE OF IT IS THE LESSON ──────────────────
//
// `school.logo.title` was a FLAT message, and its value in the shared locale files
// was the literal string "Japanese International School Munich" — in all four
// languages. So every whitelabel's logo announced itself as JISM: six `title`/`alt`
// attributes across `LogoLink` and `SideNav`, on the sign-in page and the side nav of
// all 29 consoles.
//
// It survived because of WHERE it lives and WHAT it is. A per-school value stored in
// a per-LOCALE file is correct for exactly one school and wrong for the rest, and an
// `alt` only surfaces in a tooltip or a screen reader — so nothing on screen
// disagreed with it. The variant locale override (`variants/<code>/langaugeProvider/`)
// existed the whole time and no variant used this key.
//
// ── THE FIX USES A VALUE THE BUILD ALREADY CARRIES ──────────────────────────
//
// `HEAD_TITLE` is the school's name as the browser tab already shows it, so there is
// no new config key and nothing to fill in 29 times. The message keeps the localised
// half ("… logo") and takes the brand as an argument.
//
// `_defaults/build.config.js` always supplies a HEAD_TITLE and `env.config.js` merges
// over it, so the interpolation can never be empty — pinned by
// `components/Maps/variantBuildConfig.contract.spec.js` across the whole estate,
// rather than guarded by a branch here for a state that cannot occur.
//
// A school that wants different wording can still override `school.logo.title` in its
// own variant locale file. It just has to keep the `{school}` argument.
export function schoolLogoLabel(intl) {
  return intl.formatMessage({ id: 'school.logo.title' }, { school: BuildConfig.HEAD_TITLE });
}

export default schoolLogoLabel;
